import React from 'react';
import './customheader.css'; // if needed for consistent layout

const CustomHeaderFacebookLoader = () => {
  return (
    <div className="custom-loan-header-container animate-pulse">
      <div className="custom-loan-header-content">
        {[...Array(5)].map((_, sectionIndex) => (
          <div className="loan-info" key={sectionIndex}>
            <div className="loan-info-content">
              {[...Array(3)].map((_, rowIndex) => (
                <div className="loan-info-row" key={rowIndex}>
                  <div className="loan-info-label h-4 bg-gray-300 rounded w-24 mb-1"></div>
                  <div className="loan-info-value h-4 bg-gray-200 rounded w-32"></div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomHeaderFacebookLoader;
